import _ from 'lodash';

export default class ColorHelper {
  static randomColor() {
    const h = _.random(1, 360);
    //const s = _.random(0, 100);
    //const l = _.random(85, 90);
    return `hsl(${h}, 70%, 60%)`;
  }
}



/** WEBPACK FOOTER **
 ** ./src/businessLogic/colorHelper.js
 **/